module.exports = __webpack_public_path__ + "fonts/fa-solid-900.dbf1fc91f1beec2915123257ea4d58ef.woff2";